import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-20 md:py-28">
      <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
        <div className="relative px-6 py-16 md:py-24 text-center">
          <span className="absolute inset-0 flex items-center justify-center font-heading font-bold text-[8rem] md:text-[14rem] text-background-200 select-none pointer-events-none">
            404
          </span>
          <div className="relative">
            <span className="w-16 h-16 mx-auto rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">
              <i className="ri-emotion-sad-line text-2xl"></i>
            </span>
            <h1 className="mt-5 font-heading font-bold text-2xl md:text-3xl text-foreground-950">页面走丢了</h1>
            <p className="mt-3 text-sm text-foreground-500">
              你访问的页面不存在或已被移动：<span className="text-foreground-700">{location.pathname}</span>
            </p>
            <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
              <Link to="/" className="cursor-pointer whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium px-6 py-3 rounded-full transition-colors">
                <i className="ri-home-4-line"></i> 返回首页
              </Link>
              <Link to="/news" className="cursor-pointer whitespace-nowrap inline-flex items-center gap-2 border border-background-300 hover:border-primary-400 hover:text-primary-600 text-foreground-700 text-sm font-medium px-6 py-3 rounded-full transition-colors">
                <i className="ri-newspaper-line"></i> 浏览资讯
              </Link>
              <Link to="/search" className="cursor-pointer whitespace-nowrap inline-flex items-center gap-2 border border-background-300 hover:border-primary-400 hover:text-primary-600 text-foreground-700 text-sm font-medium px-6 py-3 rounded-full transition-colors">
                <i className="ri-search-line"></i> 搜索剧集
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}